'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.booklist.add', [])
    .controller('BookListAddController', AddController)
    .name;



// WEBPACK FOOTER //
// ./client/app/booklist/add/index.js